import React, { createContext, useContext } from 'react'

export interface SaveAndDeleteCtx {
  deleteBeforeNavigate?: () => Promise<void>
}

const Ctx = createContext<SaveAndDeleteCtx>({})

export const NavigationSaveAndDeleteProvider: React.FC<React.PropsWithChildren<SaveAndDeleteCtx>> = ({
  children,
  deleteBeforeNavigate
}) => {
  return <Ctx.Provider value={{ deleteBeforeNavigate }}>{children}</Ctx.Provider>
}

export const useSaveAndDeleteBeforeNavigate = () => useContext(Ctx)
